import { copy } from "shared/assets";
import { Download, Mail } from "shared/assets/icons";
import { IActionDropdownItem } from "shared/components";
import { IStatus } from "shared/types";
import { IUserPermissions } from "shared/utils";

const { actions: actionsCopy } = copy;

export const getEventActions = ({
  handleEdit,
  handleDelete,
  handleSaveAsPDF,
  handleEmailAsPDF,
  userPermissions,
  fetchingEventBlocks,
  lastSent,
}: {
  handleEdit: () => void;
  handleDelete: () => void;
  handleSaveAsPDF?: () => void;
  handleEmailAsPDF?: () => void;
  userPermissions: IUserPermissions;
  fetchingEventBlocks?: boolean;
  lastSent?: string;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [];

  if (userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.edit,
      handleClick: handleEdit,
      dataTestId: "edit_event",
    });
  }

  if (handleSaveAsPDF && !fetchingEventBlocks) {
    actions.push({
      label: actionsCopy.saveEvent,
      handleClick: handleSaveAsPDF,
      dataTestId: "save_event_pdf",
      quickAction: true,
      icon: Download,
    });
  }

  if (userPermissions.EDIT && handleEmailAsPDF && !fetchingEventBlocks) {
    actions.push({
      label: actionsCopy.emailEvent,
      handleClick: handleEmailAsPDF,
      dataTestId: "email_event_pdf",
      quickAction: true,
      icon: Mail,
      note: lastSent,
    });
  }

  if (userPermissions.EDIT && userPermissions.DELETE) {
    actions.push({
      label: actionsCopy.delete,
      handleClick: handleDelete,
      dataTestId: "delete_event",
      status: IStatus.error,
    });
  }

  return actions;
};
